<template>
  <div v-if="goodsCardInfo" class="CarefullyChosenGoodsCard">
    <div class="picBox">
      <van-image class="pic" fit="cover" :src="goodsCardInfo.PictUrl" />
    </div>
    <div class="rightPart">
      <div class="title twoRow" v-text="goodsCardInfo.Title"></div>
      <div class="bottomPart">
        <div class="subLeftPart">
          <div class="price">
            <i class="symbol">￥</i>
            <span>{{ goodsCardInfo.CouponFinalPrice }}</span>
          </div>
          <span v-if="goodsCardInfo.TljAmount" class="subsidy"
            >补贴{{ goodsCardInfo.TljAmount }}元</span
          >
        </div>
        <div
          v-if="!goodsCardInfo.ProdInVaild"
          class="normal status1 tapActive"
          @click="goToBuy"
        >去购买</div>
        <div v-else class="normal status2">已失效</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Image as VanImage } from "vant";
export default {
  name: "SouhuoH5Carefullychosengoodscard",

  props: {
    goodsCardInfo: {
      type: Object,
    },
  },

  data() {
    return {};
  },

  components: {
    VanImage,
  },

  mounted() {},

  methods: {
    goToBuy () {
      this.$emit('goToBuy', this.goodsCardInfo)
    }
  },
};
</script>

<style lang="scss" scoped>
$base_width: 375;
@function vw($px) {
  @return ($px / $base_width) * 100vw;
}
.CarefullyChosenGoodsCard {
  display: flex;
  align-items: center;
  width: vw(350);
  height: vw(112);
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
  margin: vw(8) auto;
  padding: 0 vw(10);
  box-sizing: border-box;
  .picBox {
    width: vw(93);
    height: vw(93);
    flex-shrink: 0;
    .pic {
      width: 100%;
      height: 100%;
    }
  }
  .rightPart {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    height: vw(93);
    padding: 0 vw(10);
    box-sizing: border-box;
    .title {
      font-size: vw(15);
      color: #101010;
      font-weight: 400;
    }
    .bottomPart {
      display: flex;
      align-items: center;
      justify-content: space-between;
      align-items: flex-end;
      line-height: 1.1em;
      .subLeftPart {
        display: flex;
        align-items: center;
        .price {
          font-size: vw(18);
          color: #ff0036;
          .symbol {
            font-style: normal;
            font-size: vw(12);
          }
        }
      }
      .subsidy {
        margin-left: vw(4);
      }
      .normal {
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: vw(54);
        height: vw(24);
        background: #999999;
        border-radius: vw(3);
        color: #fff;
        font-size: vw(12);
        &.status1 {
          background-color: #ec0536;
        }
        &.status2 {
          background: #999999;
        }
      }
    }
  }
}
</style>